import { render, staticRenderFns } from "./onlineExpoBanner4.vue?vue&type=template&id=10cc9dff&"
import script from "./onlineExpoBanner4.vue?vue&type=script&lang=js&"
export * from "./onlineExpoBanner4.vue?vue&type=script&lang=js&"
import style0 from "./onlineExpoBanner4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports